module.exports = __webpack_public_path__ + "img/0492b73.png";